/*
* @providesModule CheckoutFlowModalControllerStyle
* 
*/

import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import { StyleSheet } from 'react-native';

const {
  fontSecondary,
  fontSizeH4,
  fontRegular,
  textColorSecondary,
  btnTextColorTwo,
  btnTextColorOne,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  contentContainer: {
    backgroundColor: '#FFF',
    padding: 27,
    alignItems: 'center',
    justifyContent: 'center',
  },

  rowStyle: {
    flexDirection: 'row',
    marginBottom: 10,
  },

  successModalIcon: {
    width: 45,
    height: 45,
    marginBottom: 25,
    marginTop: -5,
  },

  outOfFundsStoreIcon: {
    width: 79,
    height: 69,
    marginTop: 40,
    marginBottom: 22,
  },

  bodyText: {
    ...fontRegular,
    ...fontSizeH4,
    color: '#4A4A4A',
    textAlign: 'center',
  },

  okButtonSuccess: {
    flexDirection: 'row',
    flexGrow: 1,
    height: Sizes.select({
      smallPhone: 27,
      smallLandscapePhone: 25,
      largePhone: 35,
      minitab: 30,
      tablet: 45,
    }),
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: -5,
    marginTop: 10,
  },

  okButtonBonusCash: {
    width: 195,
    height: 35,
    marginTop: 23,
    alignSelf: 'center',
  },

  buttonArrayOutOfFunds: {
    flexDirection: 'row',
    marginBottom: 10,
    marginTop: 5
  },
  
  buttonOutOfFunds: {
    width: 130,
    height: 35,
    margin: 10
  },

  textOutOfFunds: {
    ...fontRegular,
    ...fontSizeH4,
    ...textColorSecondary,
  },

  okButtonText: {
    ...fontSecondary,
    ...fontSizeH4,
    ...btnTextColorOne,
  },

  backButtonText: {
    ...fontSecondary,
    ...fontSizeH4,
    ...btnTextColorTwo,
  },

  basicTextStyle: {
    flexGrow: 1, 
    marginLeft: 0, 
    fontSize: 15, 
    fontFamily: "HelveticaNeue", 
    color: '#4A4A4A',
    marginTop: 3,
  },

  cashStyle: {
    marginRight: 0, 
    fontSize: 20, 
    fontFamily: "HelveticaNeue-Bold",
  },

  bonusTextStyle: {
    marginTop: 3,
    flexGrow: 1,
    marginLeft: 0, 
    fontSize: 15, 
    fontFamily: "HelveticaNeue-Bold", 
    color: '#79B23F'
  },

  infoModalBodyStyle: {
    marginTop: 10, // used instead of marginVertical so that..
    marginBottom: 5, // ... these attributes will override
    fontSize: 16,
  },

  uhOhModalBodyStyle: {
    marginTop: -13, // used instead of marginVertical so that..
    marginBottom: 0, // ... these attributes will override
    fontSize: 16,
  },

  uhOhModalTitleStyle: {
    marginTop: 22,
  },

  uhOhModalButtonContainerStyle: {
    marginBottom: 20,
  },

  uhOhModalSingleButtonStyle: {
    width: Sizes.select({
      phone: '60%',
      tablet: '50%'
    }),
    height: 35,
  },

  infoModalSingleButtonStyle: {
    width: Sizes.select({
      phone: '60%',
      tablet: '50%'
    }),
    height: 35,
  },

  infoModalButtonContainerStyle: {
    marginTop: 10,
    marginBottom: 20,
  },

  infoModalTitleMarginStyle: {
    marginTop: 25,
    marginBottom: 5,
  }

});
